import React from 'react';
import PrimaryButton from './PrimaryButton';

const ErrorPage = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8f9fa] p-5">
      <div className="max-w-[500px] rounded-3xl border border-gray-100 bg-white p-10 text-center shadow-sm">
        <h1 className="mb-5 font-display text-[2rem] font-bold text-gray-900">Oeps! Er is iets misgegaan</h1>
        <p className="mb-8 text-[1.1rem] leading-normal text-gray-500">
          We hebben een foutje gemaakt. Probeer de pagina te verversen.
        </p>
        <PrimaryButton onClick={handleRefresh} className="mx-auto min-w-[200px]">
          Ververs de pagina
        </PrimaryButton>
      </div>
    </div>
  );
};

export default ErrorPage;
